<template>
    <div style="height: 100%;" class="eg_out">
        <page class="eg-page" v-if="$route.path === '/eightGragon'" @scrollChange="scrollAnimation">
            <div class="eg_content">
                <div class="egc_out">
                    <div class="egc_bcw">
                        <!--八部天龙-头部-->
                        <div class="eg_header_out">
                            <div class="egh">
                                <cms-image class="eg_logo" :class="isIE ? 'classie' : ''" :src="require('~/views/img/rg_logo.png')" @click="onClick"></cms-image>
                                <cms-image class="eg_logo_sub" :class="isIE ? 'classie' : ''" :src="require('~/views/img/eg_logo_sub.png')"></cms-image>
                                <div class="eg_nav_out">
                                    <div v-for="(item,index) in list" :key="index" :class="acIndex === index ? 'ac' : ''" @click="clickNav(index)">{{item.title}}</div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="eg_nav_out_mobile eg_nav_out">
                            <div v-for="(item,index) in list" :key="index" :class="acIndex === index ? 'ac' : ''" @click="clickNav(index)">{{item.title}}</div>
                        </div>-->
                        <!--视频-->
                        <div class="eg_video_out" v-if="video.length">
                            <div class="egv_play" v-if="!isPlay" @click="playVideo(1)">
                                <img src="./img/eg_video_play.png" alt="">
                            </div>
                            <video :src="video[0].ext1" :poster="video[0].cover" style="object-fit:cover;" ref="video"  @click="playVideo(0)"></video>
                        </div>
                        <div class="divider_eg"></div>
                        <!--一张票-->
                        <div :id="'part'+index" class="eg_part" v-for="(item,index) in list" :key="index">
                            <div class="egp_title">{{item.title}}</div>
                            <div class="egp_con" v-html="item.content"></div>
                        </div>
                    </div>
                </div>
                <div class="detailButton2" v-if="showButton" @click="toTop()">
                    <span>回到顶部</span>
                </div>
            </div>
            <zui-footer />
        </page>
    </div>
</template>

<script>
    import {
        getArticles
    } from "~/api/CmsApi";
    import './less/eightGragon.css'
    export default {
        name: "eightGragon",
        data(){
            return {
                scrollIndex: 0,
                acIndex: 0,
                isIE:false,
                isUC: false,
                isPlay: false,
                showButton: false,
                list:[],
                videoSrc:'',//视频地址
                poster:'',//视频封面图地址
                visible: true,
                video:[],
                queryIndex:-1,
            }
        },
        created() {
            this.init();
            if (document.documentMode)
                this.isIE = true;
            if (navigator.appVersion.indexOf('UBrowser/'))
                this.isUC = true;
            if ((this.isIE || this.isUC) && !document.body.scrollTo) {
                Element.prototype.scrollTo = function(option) {
                    this.scrollLeft = option.left;
                    this.scrollTop = option.top;
                };
            }
            this.queryIndex = this.$route.query.index  ? Number(this.$route.query.index) : -1;
            this.acIndex = this.$route.query.index  ? Number(this.$route.query.index) : 0;
            console.log(this.acIndex)

        },
        mounted: function() {
        },
        methods:{
            // 返回首页
            onClick: function (e) {
                location.assign('/')
            },
            // 暂停、播放视频
            playVideo(type){
                console.log(type)
                let dom = this.$refs.video;
                type === 1 ? dom.play() : dom.pause();
                this.isPlay = type ? true : false;
            },
            init() {
                // 请求8个文章
                getArticles({
                    cateId: '1760593374942928898',
                    page: 1,
                    sortBy: 1,
                    limit: 10
                }).then(res => {
                    if (res.code === 0) {
                        const list = res.data.records || [];
                        this.list = list;
                        if(this.queryIndex > -1){
                            this.$nextTick(() => {
                                this.clickNav(this.queryIndex)
                            })
                        }


                    } else {
                        console.warn('八部天龙信息获取失败');
                    }
                });
                // 请求视频
                getArticles({
                    cateId: '444',
                    page: 1,
                    limit: 999
                }).then(res => {
                    if (res.code === 0) {
                        this.video = res.data.records || [];
                    } else {
                        console.warn('视频信息获取失败');
                    }
                })
            },
            // 点击菜单
            clickNav(num){
                if(document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){
                    // this.limit = 8
                }else{
                    this.acIndex = num;
                    document.getElementById('part'+num).scrollIntoView({
                        behavior: "smooth",
                        block: 'start'
                    });
                }
            },
            // 回到顶部按钮
            scrollAnimation(e) {
                if (e > 300) {
                    this.showButton = true
                } else {
                    this.showButton = false
                }
            },
            // 返回顶部
            toTop() {
                if (this.isIE || this.isUC)
                    this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTop = 0;
                else
                    this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/eightGragon.vue